import { render } from "./OrderDetailsModalTable.vue?vue&type=template&id=6bc5dc55"
import script from "./OrderDetailsModalTable.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModalTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__